import { EventMapping, Sensors } from '../types';

export class EventMappings {
  protected translateFn: Function;

  public sensorName: Sensors;
  public mappings: { [name: string]: EventMapping };

  public constructor({ translateFn }: { translateFn: Function }) {
    this.translateFn = translateFn;
  }
}
